"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var message_list_button_1 = __importDefault(require("~/components/users/estimates/requests/unread_request/request_list/message_list_button"));
var icons_comment_dots_orange_png_1 = __importDefault(require("images/sprites/ui/icons_comment_dots_orange.png"));
var Header = function (props) {
    var toggleLineClass = (0, classnames_1.default)("unreadRequestWindow-Header_ToggleLine", {
        "unreadRequestWindow-Header_ToggleLine-open": props.isWindowOpened,
        "unreadRequestWindow-Header_ToggleLine-close": !props.isWindowOpened
    });
    return (react_1.default.createElement("div", { className: "unreadRequestWindow-Header" },
        react_1.default.createElement("i", { className: toggleLineClass, onClick: props.onClickHeader }),
        react_1.default.createElement("div", { className: "unreadRequestWindow-Header_TitleWrapper", onClick: props.onClickHeader },
            react_1.default.createElement("img", { src: icons_comment_dots_orange_png_1.default, alt: "", className: "unreadRequestWindow-Header_CommentIcon lazyload" }),
            react_1.default.createElement("span", { className: "unreadRequestWindow-Header_Title" }, "\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u5C4A\u304D\u307E\u3057\u305F\uFF01")),
        props.isWindowOpened
            ? react_1.default.createElement(message_list_button_1.default, { onClickMessageListButton: props.onClickMessageListButton })
            : react_1.default.createElement("i", { className: "fa fa-times unreadRequestWindow-Header_CloseButton", onClick: props.onClickCloseButton })));
};
exports.default = Header;
